import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {resetActionCalendarPrint} from "../../../../store/action.reducer";
import {Eventcalendar} from "@mobiscroll/react";

export const useCalendarPrint = (calendarRef: React.MutableRefObject<Eventcalendar | null>) => {
    const printActionTriggered = useSelector((state: any) => state.action.actionTriggered)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!printActionTriggered) return

        setTimeout(() => {
            calendarRef.current?.print({
                baseUrl: window.location.origin,
            })

            dispatch(resetActionCalendarPrint())
        }, 50)
    }, [printActionTriggered])
}
